module.exports = __webpack_public_path__ + "static/media/gavin.846a0e1c.jpg";